module.exports = __webpack_public_path__ + "c870b6cea3ff2532e65d8e0f207924e1.jpg";